// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4062":"b999066d9fea1f9d","4065":"5fbae5be4484043e","6080":"901776250e5ac8c1","6851":"d45637c797dd7fd5"}[chunkId] + ".css";
};